import React from "react";

import SessionFormInput from "@ats/src/views/sessions/components/SessionFormInput";
import FormContainer from "@ats/src/components/forms/FormContainer";
import SessionButton from "@ats/src/views/sessions/components/SessionButton";

import { validateOnboardingProfile } from "@shared/lib/validateWithYup";

import { useUpdateMe } from "@shared/queryHooks/useMe";

function ProfileForm(props) {
  const [state, setState] = React.useState({
    firstName: "",
    lastName: "",
  });

  const [errors, setErrors] = React.useState(null);

  const { firstName, lastName } = state;
  const { mutate: updateMe, isLoading: isLoadingUpdateMe } = useUpdateMe();

  const handleSubmit = async (e) => {
    e.preventDefault();
    window.logger("%c[ProfileForm] handleSubmit state", "color: #1976D2", state);

    setErrors(null);

    const [isValid, validationErrors] = await validateOnboardingProfile({
      firstName,
      lastName,
    });

    if (isValid) {
      window.logger("%c[ProfileForm] isValid", "background-color:rgb(248, 245, 76); color: #1976D2", isValid);
      // Track AdRoll signup completion BEFORE mutation (cache update causes redirect race)
      try {
        if (window.__adroll && props.wasInvited) {
          window.logger("%c[ProfileForm] recording user to AdRoll for signup_complete", "background-color:rgb(248, 245, 76); color: #1976D2");
          window.__adroll?.record_user({
            adroll_segments: "e455fbc5",
            adroll_user_identifier: props.currentUser?.id,
            adroll_custom_data: { USER_ID: props.currentUser?.id },
          });
        } else if (window.__adroll && props.isNewOwner) {
          window.logger("%c[ProfileForm] recording user to AdRoll for new_org_owner_name_entered", "background-color:rgb(248, 245, 76); color: #1976D2");
          window.__adroll?.record_user({
            adroll_segments: "7feab026",
            adroll_user_identifier: props.currentUser?.id,
            adroll_custom_data: { USER_ID: props.currentUser?.id },
          });
        }
      } catch (error) {
        window.logger("%c[ProfileForm] error recording user to AdRoll", "background-color:rgb(248, 245, 76); color: #1976D2", error);
      }

      updateMe(
        {
          user: {
            firstName,
            lastName,
          },
        },
        {
          onSuccess: (data) => {
            window.logger("[ProfileForm] onSuccess", { data });
            props.onComplete();
          },
          onError: (response: any) => {
            window.logger("[ProfileForm] server error", { response });
            if (response.data.errors) {
              setErrors(response.data.errors);
            }
          },
        },
      );
    } else {
      setErrors(validationErrors);
    }
  };

  const handleInputChange = (name, value) => {
    setErrors(null);
    setState({ ...state, [name]: value });
  };

  const button = (
    <SessionButton type="submit" disabled={isLoadingUpdateMe} loading={isLoadingUpdateMe}>
      Next
    </SessionButton>
  );

  return (
    <FormContainer onSubmit={handleSubmit} errors={errors} buttons={button}>
      <SessionFormInput
        onChange={handleInputChange}
        name="firstName"
        placeholder=""
        label="First name"
        className=""
        errors={errors}
      />

      <SessionFormInput
        onChange={handleInputChange}
        name="lastName"
        placeholder=""
        label="Last name"
        className=""
        errors={errors}
      />
    </FormContainer>
  );
}

export default ProfileForm;
